import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';

export default function PaymentFailed({ message, onRetry }) {
  return (
    <div className="pg-admin-card rounded-[var(--pg-radius-md)] p-8 text-center" data-testid="payment-failed">
      <div className="inline-flex h-14 w-14 rounded-full bg-[rgba(255,62,165,0.12)] border border-[rgba(255,62,165,0.5)] items-center justify-center mb-4">
        <AlertCircle size={28} className="text-[var(--pg-neon-pink)]" />
      </div>
      <h2 className="font-serif text-2xl text-[var(--pg-ink)]">Payment could not be completed</h2>
      <p className="text-sm text-[var(--pg-ink-muted)] mt-2">
        {message || 'Something went wrong. No charges were captured. You can safely try again.'}
      </p>
      {onRetry && (
        <button onClick={onRetry} data-testid="payment-retry"
                className="mt-6 inline-flex items-center gap-2 pg-btn-primary rounded-[var(--pg-radius-sm)] px-4 py-2 text-sm">
          <RefreshCw size={14} /> Try again
        </button>
      )}
    </div>
  );
}
